import styled from "styled-components";

export const Picture = styled.picture`
    z-index: 0;
`;

export const Img = styled.img<{isBackground?: boolean}>`
    ${props => props.isBackground && `object-fit: cover;`}
`;